import React, { useState } from "react";
import { Search } from "lucide-react";
import { colorForIndex } from "../utils/colors";
import { uniqueAreas } from "../utils/areas";

const ZonesLegendSidebar = ({
  zones,
  visibleZoneIds,
  onToggleVisible,
  emphasizedZoneId,
  onEmphasize,
}) => {
  const [search, setSearch] = useState("");

  const filtered = zones
    .map((zone, index) => ({ ...zone, color: colorForIndex(index) }))
    .filter((zone) =>
      `${zone.number || ""} ${zone.name}`
        .toLowerCase()
        .includes(search.toLowerCase()),
    );

  return (
    <div className='flex-[0_0_320px] border-r border-lightGray bg-white flex flex-col h-full overflow-y-auto'>
      <div className='p-5 pb-3'>
        <div className='relative'>
          <Search
            size={15}
            className='absolute left-3 top-1/2 -translate-y-1/2 text-primaryAsh'
          />
          <input
            className='w-full pl-9 pr-3 py-2.5 text-sm border border-lightGray rounded-md outline-none focus:border-primaryGreen'
            placeholder='Search zones…'
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <p className='text-xs text-primaryAsh mt-3'>
          {filtered.length} of {zones.length} zones shown
        </p>
      </div>

      <div className='flex-1 px-3 pb-4 flex flex-col gap-1'>
        {filtered.map((zone) => {
          const emphasized = emphasizedZoneId === zone.id;
          const areaCount = uniqueAreas(zone.areas || []).length;
          return (
            <div
              key={zone.id}
              className={`flex items-center gap-2.5 px-2.5 py-2.5 rounded-lg ${
                emphasized ? "bg-bgGreen border border-primaryGreen/30" : ""
              }`}
            >
              <input
                type='checkbox'
                checked={visibleZoneIds.has(zone.id)}
                onChange={() => onToggleVisible(zone.id)}
                className='w-4 h-4 accent-current flex-shrink-0'
                style={{ accentColor: zone.color }}
              />
              <span
                className='w-2.5 h-2.5 rounded-full flex-shrink-0'
                style={{ background: zone.color }}
              />
              <button
                type='button'
                onClick={() => onEmphasize(emphasized ? null : zone.id)}
                className='flex-1 min-w-0 text-left'
              >
                <p className='text-sm font-semibold text-primaryBlack truncate'>
                  Zone {zone.number || zone.id}
                </p>
                <p className='text-[11px] text-primaryAsh truncate'>
                  {areaCount} areas
                  {zone.name ? ` · ${zone.name}` : ""}
                </p>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ZonesLegendSidebar;
